/* @flow */
import React from 'react';

import Column from 'components/UIKit/Flex/Column';
import Type from './Type';
import Handle from './Handle';

let baseStyle = {
  backgroundColor: '#fafafa',
  borderLeft: '1px solid #e5e5e5',
  color: '#888',
};

export default function Navigation({
  details, children, type, active, handleOnClick, style
}: any): React.Element {
  let isFetching = (details || {}).isFetching || false;

  return (
    <Column style={{...baseStyle, ...style}}>
      <Type isFetching={isFetching}>{type}</Type>
      <Handle />
      {React.Children.map(children, child => {
        return child && React.cloneElement(child, {
          active,
          handleOnClick: () => handleOnClick(child.props.spyId)
        });
      })}
    </Column>
  );
}
